import React, { useEffect, useState } from "react";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { handleError, handleSuccess } from "../../../Utils";
import CloseIcon from "@mui/icons-material/Close";
import { addBankAccountDetails, getBankAccountDetails } from "../../../ApiServices/ApiServices";

function BankAccountDetails({isVisible, setIsVisible, setIsBankAccountConnected}) {
  const email = getEmail();

  const [accountType, setAccountType] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    
    const getAccountData = async()=>{
      try {
        const response = await getBankAccountDetails(email);
        setAccountType(response.data.accountType);
        setAccountHolderName(response.data.accountHolderName);
        setIfscCode(response.data.ifscCode);
        setAccountNumber(response.data.accountNumber);
        setConfirmAccountNumber(response.data.accountNumber);
      } catch (error) {
        return handleError(error?.response?.data?.message)
      }finally{
        setLoading(false);
      }
    }
    if(email){
      getAccountData();
    }
  },[email])

  const [errors, setErrors] = useState({
    accountType: "",
    accountHolderName: "",
    ifscCode: "",
    accountNumber: "",
    confirmAccountNumber: "",
  });

  // Handle Account Type Selection
  const handleAccountTypeSelect = (type) => {
    setAccountType(type);
    setErrors((prev) => ({ ...prev, accountType: "" })); // Clear any previous error
  };

  // Handle form submission
  const handleFormSubmit = async (event) => {
    event.preventDefault();

    // Validate form data
    let tempErrors = {};

    if (!accountHolderName) {
      tempErrors.accountHolderName = "Account Holder Name is required.";
    }
    if (!ifscCode) {
      tempErrors.ifscCode = "IFSC Code is required.";
    }
    if (!accountNumber) {
      tempErrors.accountNumber = "Account Number is required.";
    }
    if (accountNumber !== confirmAccountNumber) {
      tempErrors.confirmAccountNumber = "Account number did not match";
    }
    if (!accountType) {
      tempErrors.accountType = "Account Type is required.";
    }

    setErrors(tempErrors);

    if(email && accountType && accountHolderName && ifscCode && accountNumber && accountNumber===confirmAccountNumber){
      try {
        const bankDetails = {
          email: email,
          accountType: accountType,
          accountHolderName: accountHolderName,
          ifscCode: ifscCode,
          accountNumber: accountNumber,
        };
        const response = await addBankAccountDetails(bankDetails);
        handleSuccess(response.message);
        setAccountType("");
        setAccountHolderName("");
        setIfscCode("");
        setAccountNumber("");
        setConfirmAccountNumber("");
        setIsVisible(!isVisible);
        setIsBankAccountConnected(true);
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    }
  };
  if (loading) return <p>Loading profile...</p>;
  return (
    <div>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
        <div className="bg-white px-4 pb-4 rounded-lg w-[400px] m-1 relative">
          {/* Form Heading */}
          <div className="text-2xl text-left font-bold text-gray-700 mt-3">
            Bank Account Details
          </div>
          <div className="close-icon" onClick={()=>setIsVisible(!isVisible)}>
            <CloseIcon/>
          </div>
          <form onSubmit={handleFormSubmit}>
            {/* Account Type */}
            <div className="mb-2">
              <label
                htmlFor="accountType"
                className="block text-base text-gray-600 font-medium"
              >
                Account Type
              </label>
              <div className="flex space-x-4">
                <div
                  onClick={() => handleAccountTypeSelect("Savings")}
                  id="savingsOption"
                  className={`cursor-pointer p-2 w-full text-center border rounded-md ${
                    accountType === "Savings"
                      ? "border-black bg-gray-400 font-bold"
                      : "border-gray-300 text-gray-500"
                  }`}
                >
                  Savings
                </div>
                <div
                  onClick={() => handleAccountTypeSelect("Current")}
                  id="currentOption"
                  className={`cursor-pointer p-2 w-full text-center border rounded-md ${
                    accountType === "Current"
                      ? "border-black bg-gray-400 font-bold"
                      : "border-gray-300 text-gray-500"
                  }`}
                >
                  Current
                </div>
              </div>
              {errors.accountType && (
                <p className="text-red-500 text-sm">{errors.accountType}</p>
              )}
            </div>

            {/* Account Holder Name */}
            <div className="mb-2">
              <label
                htmlFor="accountHolderName"
                className="block text-base text-gray-600 font-medium"
              >
                Account Holder Name
              </label>
              <input
                type="text"
                id="accountHolderName"
                className="w-full px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={accountHolderName}
                onChange={(e) => setAccountHolderName(e.target.value)}
              />
              {errors.accountHolderName && (
                <p className="text-red-500 text-sm">
                  {errors.accountHolderName}
                </p>
              )}
            </div>

            {/* IFSC Code */}
            <div className="mb-2">
              <label
                htmlFor="ifscCode"
                className="block text-base text-gray-600 font-medium"
              >
                IFSC Code
              </label>
              <input
                type="text"
                id="ifscCode"
                className="w-full px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={ifscCode}
                onChange={(e) => setIfscCode(e.target.value)}
              />
              {errors.ifscCode && (
                <p className="text-red-500 text-sm">{errors.ifscCode}</p>
              )}
            </div>

            {/* Account Number */}
            <div className="mb-2">
              <label
                htmlFor="accountNumber"
                className="block text-base text-gray-600 font-medium"
              >
                Account Number
              </label>
              <input
                type="text"
                id="accountNumber"
                className="w-full px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
              />
              {errors.accountNumber && (
                <p className="text-red-500 text-sm">{errors.accountNumber}</p>
              )}
            </div>

            {/* Confirm Account Number */}
            <div className="mb-2">
              <label
                htmlFor="confirmAccountNumber"
                className="block text-base text-gray-600 font-medium"
              >
                Confirm Account Number
              </label>
              <input
                type="text"
                id="confirmAccountNumber"
                className="w-full px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={confirmAccountNumber}
                onChange={(e) => setConfirmAccountNumber(e.target.value)}
              />
              {errors.confirmAccountNumber && (
                <p className="text-red-500 text-sm">
                  {errors.confirmAccountNumber}
                </p>
              )}
            </div>

            {/* Save Button */}
            <div className="mt-6">
              <button
                type="submit"
                className="w-full py-2 bg-black text-white font-semibold rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BankAccountDetails;
